import { TableCell } from '@/common/components/Table/Table'
import { TableRow } from '@/common/components/Table/Table'
import ReactCountryFlag from 'react-country-flag'
import { Partnership, PartnershipStatus } from '@/common'
import useI18n from '@/shared/hooks/useI18n'
import { BellAlertIcon, EnvelopeIcon } from '@heroicons/react/24/solid'

export default function PendingImporterRow({ partnership }: { partnership: Partnership }) {
  const { dateFormatter } = useI18n()
  const creationDate = dateFormatter(new Date(partnership.createdAt))
  const invitationDate = partnership.invitationSentAt
    ? dateFormatter(new Date(partnership.invitationSentAt))
    : '-'
  const invitationEmail = partnership.invitationEmail

  return (
    <>
      <TableRow key={partnership.id} className="w-full">
        <TableCell>
          <div className="flex items-start gap-2">
            <ReactCountryFlag countryCode={partnership.country} className="relative top-1" svg />
            <span>{partnership.name}</span>
          </div>
        </TableCell>
        <TableCell>{creationDate}</TableCell>
        <TableCell>{invitationDate}</TableCell>
        <TableCell>
          {partnership.status === PartnershipStatus.CREATED && '-'}
          {partnership.status === PartnershipStatus.INVITATION_SENT &&
            (invitationEmail ? (
              <span title="Invited via email" className="flex items-center gap-2">
                <EnvelopeIcon className="size-4" />
                {invitationEmail}
              </span>
            ) : (
              <span title="Invited via ARTEM" className="flex items-center gap-2">
                <BellAlertIcon className="size-4" />
                ARTEM
              </span>
            ))}
        </TableCell>
      </TableRow>
    </>
  )
}
